import Modal from 'components/modal';
import React from 'react';
import DeleteForm from './deleteForm';
interface DeleteModalProps {
  app: 'farm' | 'wholesaler';
  isOpen: boolean;
  type: 'post' | 'wanted-post';
  delete_reason: 'unsuccessful' | 'successful' | 'canceled' | 'unknown';

  guid: string;
  setIsopen: (isOpen: boolean) => void;
  refetch: () => void;
}
const DeleteModal = ({
  app,
  isOpen,
  type,
  guid,
  delete_reason,
  setIsopen,
  refetch,
}: DeleteModalProps) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsopen}>
      <div className="flex w-full flex-col gap-4  bg-white  p-4 rounded-lg">
        <DeleteForm
          delete_reason={delete_reason}
          type={type}
          app={app}
          guid={guid}
          setIsopen={setIsopen}
          refetch={refetch}
        />
      </div>
    </Modal>
  );
};

export default DeleteModal;
